import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { Store } from '@ngrx/store';
import { State } from '../../store/reducers';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';

import { zip } from 'rxjs/observable/zip';

@Injectable()
export class AddBookingGuard implements CanActivate {
  admins = ['jlandzro@gmail.com', 'enoch@abassey.com'];
  constructor(private store: Store<State>, private authService: AuthService) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return zip(this.authService.user, this.store.select(s => s.payment)).pipe(
      map(data => {
        const isAdmin =
          this.admins.includes(data[0].email) ||
          (!data[1].paidForAccommodation && !data[1].paidForConference);
        return isAdmin;
      })
    );
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/services/add-booking.guard.ts